import styled from "@emotion/styled";
import { Button } from "@mui/material";
import { Article } from "lib/articles";
import { useState } from "react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/effect-fade";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useIsDesktop, useIsLargeDesktop } from "ui";
import { LeftArrowShort, RightArrowShort } from "ui/icons";
import ArticleCard from "./ArticleCard";
import { trackArticleHomePageClick, trackArticleSidebarClick } from "reusable/ChargeGTM";

const StyledWrapper = styled.div`
  ${(props) => props.theme.breakpoints.down("md")} {
    padding-bottom: 10px;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    width: 100%;
    display: flex; align-items: center; justify-content: flex-start;
  }
`
const StyledArrowContainer = styled(Button)`
  &:disabled {
    svg {
      path {
        stroke: rgba(21, 62, 105, 0.3);
      }
    }
  }
  button {
    padding-left: 0px; 
    padding-right: 0px; 
  }
`
const StyledArrowAtSide = styled(Button) <{ position: "left" | "right" }>`
  &:disabled {
    svg {
      path {
        stroke: rgba(21, 62, 105, 0.3);
      }
    }
  }
  display: none;
  ${(props) => props.theme.breakpoints.up("md")} {
    width: 50px;
    height: 50px;
    position: absolute;
    ${(p) => `${p.position} : -60px;`}
    top: 45%;
    display: flex;
  }
`
const StyledArrowsContainer = styled.div`
  display: flex;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 15px; 
${(props) => props.theme.breakpoints.up("md")} {
  display: none;
  }
`
const StyledSwiperSlide = styled(SwiperSlide)`
   height: auto !important;
`
const StyledSwiperPositionWrapper = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    position: relative;
    width: 100%;
    padding-top: 20px;
    padding-bottom: 10px;
  }
`
type Props = {
  articles: Article[],
  arrowsAtTop?: boolean,
  arrowsAtEachSide?: boolean,
}
function MoreArticlesSwiper({ articles }: Props) {
  const [activeIndex, setActiveIndex] = useState<number>(1)
  const isDesktop = useIsDesktop()
  const isLargeDesktop = useIsLargeDesktop()

  return (
    <StyledWrapper>
      <StyledArrowsContainer>
        <StyledArrowContainer className={`arrow-right arrow`}>
          <RightArrowShort color={"black"} size={30} />
        </StyledArrowContainer>
        <StyledArrowContainer className={`arrow-left arrow`}>
          <LeftArrowShort size={30} />
        </StyledArrowContainer>
      </StyledArrowsContainer>


      <StyledSwiperPositionWrapper>
        <StyledArrowAtSide className={`arrow-right arrow`} position="left" aria-label="לכתבה הקודמת">
          <RightArrowShort color={"rgba(17, 24, 39, 1)"} size={40} />
        </StyledArrowAtSide>
        <Swiper
          key={1}
          style={{ padding: 0 }}
          modules={[Navigation]}
          navigation={{
            nextEl: `.arrow-left`,
            prevEl: `.arrow-right`,
          }}
          onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex + 1)}
          slidesPerView={isDesktop ? isLargeDesktop ? 4 : 3 : 1.4}
          spaceBetween={20}
        >
          {articles.map((article: Article, index: number) => {
            const onClickAddedLogic = () => {
              trackArticleHomePageClick(article.name, index + 1)
            }
            return (
              <StyledSwiperSlide key={index.toString()}>
                <ArticleCard article={article} position={index} onClickAddedLogic={onClickAddedLogic} />
              </StyledSwiperSlide>
            )
          })}
        </Swiper>
        <StyledArrowAtSide className={`arrow-left arrow`} position="right"  aria-label="לכתבה הבאה">
          <LeftArrowShort size={40} />
        </StyledArrowAtSide>
      </StyledSwiperPositionWrapper>
    </StyledWrapper>
  );
}
export default MoreArticlesSwiper;
